import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {Unsubscribable} from "../../../../../mixin/unsubscribable.component";
import {EmailValidator} from "../../../../../../model/email-validator";
import {SignerQualityEnum, AuthTypeEnum} from '../../../../../../enums/dropdown.enums';
import {Observable} from "rxjs";
import {SelectItem} from "primeng/api";
import {DropdownService} from "../../../../../../services/crossComponent/drop-down.service";
import {LreRecipient} from "../../../../../../model/lre-recipient";
import {PostalAddress} from "../../../../../../model/postal-address";
import {AddressLine} from "../../../../../../model/address-line";

@Component({
  selector: 'app-deposit-erl-recipient',
  templateUrl: './deposit-erl-recipient.component.html',
  styleUrls: ['./deposit-erl-recipient.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DepositErlRecipientComponent extends Unsubscribable(class {}) implements OnInit{

  @Input() selectedRow: PostalAddress;
  @Input() recipient: LreRecipient;
  @Input() index: number;
  public currentRecipientAddress: any;
  @Output() public finalRecipient: EventEmitter<any> = new EventEmitter<any>();

  public openSenderAddress: boolean;

  public titleItems$: Observable<SelectItem[]> = this.dropdownService.getTitleItems().pipe(this.takeUntilDestroyed());
  public authTypeItems$: Observable<SelectItem[]> = this.dropdownService.getAuthTypeItems().pipe(this.takeUntilDestroyed());
  public signerQualityItems$: Observable<SelectItem[]> = this.dropdownService.getSignerQualityItems().pipe(this.takeUntilDestroyed());

  constructor(private dropdownService: DropdownService) {
    super();
  }

  ngOnInit() {
    this.recipient = this.selectedRow.recipient;
    this.currentRecipientAddress = {
      sElem: this.selectedRow.sElem,
      country: this.selectedRow.sCountryID === "FR" ? "FRANCE" : null,
      mElemByName: this.selectedRow.mElemByName
    };
  }

  public handleRecipientAddress(address: any): void {
    this.currentRecipientAddress = {
      sElem: address.fa,
      mElemByName: this.addressLinesToMap(address.lines)
    };
    this.selectedRow.fields = this.addressLinesToMap(address.lines);
    this.selectedRow.formatted = address.fa;
    this.recipient.address = [];
    this.recipient.address.push(address.fa.join('\n'));
  }

  private addressLinesToMap(lines: AddressLine[]): any {
    const map: any = {};
    for (const line of lines) {
      map[line.sDataName] = line.sDataValue;
    }
    return map;
  }

  public nextEnabled(): boolean {
      if (!this.recipient) return false;

      const isProfessional = this.recipient.signerQuality === SignerQualityEnum.PROFESSIONAL;
      const isIndividual = this.recipient.signerQuality === SignerQualityEnum.INDIVIDUAL;

      const hasValidMail = !!this.isValidMail(this.recipient.mailAddress);  // Conversion en boolean
      const hasValidAuthentication = (
        (this.recipient.authenticationType === AuthTypeEnum.SMS && !!this.recipient.phoneNumber) ||  // Conversion en boolean
        (this.recipient.authenticationType === AuthTypeEnum.EMAIL && !this.recipient.phoneNumber)
      );

      const isValidProfessional = isProfessional && !!this.recipient.company && !this.recipient.title && !this.recipient.firstName && !this.recipient.lastName;
      const isValidIndividual = isIndividual && !!this.recipient.title && !!this.recipient.firstName && !!this.recipient.lastName && !this.recipient.company;

      return (isValidProfessional || isValidIndividual) && hasValidMail && hasValidAuthentication && this.isValidAddress(this.recipient.address);
  }

  public closeComponent(): void {
    this.selectedRow.valid = true;
    this.selectedRow.recipientMail = this.recipient.mailAddress;
    this.selectedRow.validIdentityRecipient = true;
    this.finalRecipient.emit({updateRecipient: this.selectedRow, index: this.index});
  }

  public showSenderAddress() {
    this.openSenderAddress = true;
  }

  public handleSenderAddressClose(result: boolean): void {
    this.openSenderAddress = result;
  }

  public isValidMail(mail: string): boolean {
    return EmailValidator.emailIsValid(mail);
  }

  public isValidAddress(address: string[]): boolean {
    return address && address.length > 0 && address[0].split('\n').length >= 2;
  }

  public onTypeActorChange(newValue: string): void {
    if (newValue === SignerQualityEnum.PROFESSIONAL) {
      this.recipient.title = null;
      this.recipient.firstName = null;
      this.recipient.lastName = null;
    } else {
      this.recipient.company = null;
    }
  }

  public onAuthenticationChange(newAuthentication: string): void {
    if (newAuthentication === AuthTypeEnum.EMAIL) {
      this.recipient.phoneNumber = null;
    }
  }

  protected readonly SignerQualityEnum = SignerQualityEnum;
  protected readonly AuthTypeEnum = AuthTypeEnum;
}
